import createCache from '@emotion/cache';
export function createEmotionCache(key) {
    return createCache({ key, prepend: true });
}
//# sourceMappingURL=createEmotionCache.js.map